import { render } from "./ValidationRules.vue?vue&type=template&id=1da2430f"
import script from "./ValidationRules.vue?vue&type=script&lang=ts"
export * from "./ValidationRules.vue?vue&type=script&lang=ts"
script.render = render

export default script